// extracted by mini-css-extract-plugin
export var option = "MultiLegOption-module--option--666fa";
export var optionSelected = "MultiLegOption-module--optionSelected--055ac";